import { useQuery } from '@tanstack/react-query'

import { get } from '../apiClient'
import { pincodeResponseSchema } from '../../../common/validations/reservationSchema'
import { API_ENDPOINTS } from '../../../common/apiEndpoints'

const params = (
  contractUuid: string,
  reservationRecurrenceId: number,
  enabled: boolean
) => {
  const path = API_ENDPOINTS.RESERVATION_RECURRENCE_PINCODE.replace(
    ':contractUuid',
    contractUuid
  ).replace(':reservationRecurrenceId', reservationRecurrenceId.toString())

  return {
    queryKey: [
      'reservation-recurrence-pincode',
      contractUuid,
      reservationRecurrenceId,
    ],
    queryFn: async () => {
      return get(path, pincodeResponseSchema)
    },
    enabled,
  }
}

export const useAPIGetReservationRecurrencePincode = (
  contractUuid: string,
  reservationRecurrenceId: number,
  enabled: boolean
) => {
  return useQuery(params(contractUuid, reservationRecurrenceId, enabled))
}
